import { motion } from 'framer-motion';
import { UserPlus, Users, Download } from 'lucide-react';

function QuickActions({ onAddEmployee, onViewEmployees, onExportCSV }) {
  const actions = [
    {
      icon: UserPlus,
      label: 'Add Employee',
      onClick: onAddEmployee,
      gradient: 'from-blue-500 to-cyan-500',
    },
    {
      icon: Users,
      label: 'View Employees',
      onClick: onViewEmployees,
      gradient: 'from-purple-500 to-pink-500',
    },
    {
      icon: Download,
      label: 'Export CSV',
      onClick: onExportCSV,
      gradient: 'from-green-500 to-emerald-500',
    },
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-200 dark:border-gray-700">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        Quick Actions
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {actions.map((action, index) => {
          const Icon = action.icon;
          return (
            <motion.button
              key={action.label}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.1, duration: 0.3 }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={action.onClick}
              className={`p-4 rounded-lg bg-gradient-to-br ${action.gradient} text-white font-medium hover:shadow-lg transition-all flex flex-col items-center gap-2`}
            >
              <Icon size={20} />
              <span className="text-sm">{action.label}</span>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
}

export default QuickActions;
